import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';

import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from 'react-router-dom';

const UserProp = forwardRef((props, ref) => {

    //#region const 

    let navigate = useNavigate();
    const [Id, setId] = useState(General.GuidEmpty());
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [UserName, setUserName] = useState("");
    const [Password, setPassword] = useState("");
    const [Permission, setPermission] = useState(-1); // 0: Admin, 1: User
    const [ShowLoader, setShowLoader] = useState(false);
    const [IsActive, setIsActive] = useState(true);
    //#endregion

    //#region Methods 

    useImperativeHandle(ref, () => ({
        ShowEdit(Id) {
            if (Id != undefined)
                setId(Id);
        }
    }))



    const handleSubmit = (e) => {
        e.preventDefault();
        if (FirstName === "") {
            General.ShowMsg(Enum.MsgType.error, "نام را وارد نمایید");
            return;
        }
        if (LastName === "") {
            General.ShowMsg(Enum.MsgType.error, "نام خانوادگی را وارد نمایید");
            return;
        }
        if (UserName === "") {
            General.ShowMsg(Enum.MsgType.error, "نام کاربری را وارد نمایید");
            return;
        }
        if (Password === "") {
            General.ShowMsg(Enum.MsgType.error, "کلمه عبور را وارد نمایید");
            return;
        }
        if (Permission === -1 || Permission === null) {
            General.ShowMsg(Enum.MsgType.error, "سطح دسترسی را وارد نمایید");
            return;
        }
        setShowLoader(true);
        var RequestOption = {
            method: 'Post',
            url: General.ApiRoute() + '/User/Save',
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
            data: {
                "Id": Id,
                "FirstName": FirstName,
                "LastName": LastName,
                "UserName": UserName,
                "Password": Password,
                "Permission": Permission,
                "IsActive": IsActive,
                "LoginError": "."
            },
            withCredentials: true
        }
        trackPromise(
            axios(RequestOption)
                .then(function (res) {
                    if (res.data.isSuccess) {

                        General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                        setShowLoader(false);
                        props.onSubmit();
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, res.data.error);
                        setShowLoader(false);
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                        }
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                        setShowLoader(false);
                    }
                })
        )
    };

    const BindUser = () => {
        setShowLoader(true);
        var RequestOption = {
            mthod: 'Get',
            url: General.ApiRoute() + "/User/GetById",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            }
            , withCredentials: true


        }

        axios(RequestOption)
            .then(function (res) {
                setFirstName(res.data.firstName);
                setLastName(res.data.lastName);
                setUserName(res.data.userName);
                setPassword(res.data.password);
                setPermission(res.data.permission);
                setIsActive(res.data.isActive);
                setShowLoader(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                    }
                    else if (error.response.status === 403) {
                        General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }

    useEffect(() => {
        if (Id != General.GuidEmpty())
            BindUser();
    }, [Id])
    //#endregion


    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>نام</label>
                <rsuite.Input
                    type="text"
                    value={FirstName}
                    onChange={value => setFirstName(value)}
                    required />
            </div>
            <div>
                <label>نام خانوادگی</label>
                <rsuite.Input
                    type="text"
                    value={LastName}
                    onChange={value => setLastName(value)}
                    required />
            </div>
            <div>
                <label>نام کاربری</label>
                <rsuite.Input
                    type="text"
                    value={UserName}
                    onChange={value => setUserName(value)}
                    required
                />
            </div>
            <div>
                <label>رمز عبور</label>
                <rsuite.Input
                    type="password"
                    value={Password}
                    onChange={value => setPassword(value)}
                    required
                />
            </div>
            <div>
                <label>دسترسی</label>
                <rsuite.SelectPicker
                    searchable={false}
                    data={[
                        { label: "مدیر سیستم", value: 0 },
                        { label: "کارشناس", value: 1 },
                    ]}
                    value={Permission}
                    onChange={value => setPermission(value)}
                    className="w-100"
                    placeholder="انتخاب کنید"
                />
            </div>
            <div>
                <rsuite.Checkbox checked={IsActive} onChange={() => setIsActive(!IsActive)} /> فعال می باشد
            </div>
            <rsuite.Divider />
            <div align="left">
                {
                    !ShowLoader ?

                        <rsuite.Button appearance="primary" className="mt-2" onClick={handleSubmit}>
                            ثبت کاربر
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mt-2" disabled>
                            <rsuite.Loader content="در حال ارسال اطلاعات..." />
                        </rsuite.Button>
                }
            </div>

        </form>
    );
});

export default UserProp;